import React, { FC } from 'react';
import { Box, Button, Card, Chip, Grid, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CbaPaperSummary, canSit, describeHistory, formatDuration, startLabel } from './cbaApi';

/**
 * Mock paper cards. Each carries what this student has done with the paper, so
 * the choice of which to sit next is made here rather than after opening one.
 *
 * `compact` lays them out as a grid of small cards instead of full-width rows.
 */
const PaperList: FC<{ papers: CbaPaperSummary[]; compact?: boolean }> = ({ papers, compact }) => {
  const navigate = useNavigate();

  if (compact) {
    return (
      <Grid container spacing={1.5} sx={{ mt: 1.5 }}>
        {papers.map((paper) => {
          const resumable = !!paper.inProgressAttempt && !paper.inProgressAttempt.expired;

          return (
            <Grid item xs={6} sm={4} md={2} key={paper.id}>
              <Card
                onClick={() => navigate(`/cba/papers/${paper.id}`)}
                sx={{
                  p: 1.5,
                  height: '100%',
                  borderRadius: 2,
                  boxShadow: '0 1px 6px #0000001A',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.5,
                  cursor: 'pointer',
                }}>
                <Typography variant='subtitle2' sx={{ fontWeight: 600, lineHeight: 1.3 }}>
                  {paper.title}
                </Typography>
                {/* <Typography variant='caption' sx={{ color: 'text.secondary' }}>*/}
                {/*  {paper.questionCount} questions · {formatDuration(paper.durationMinutes)}*/}
                {/* </Typography>*/}
                {/* <Typography variant='caption' sx={{ color: 'text.secondary' }}>*/}
                {/*  {describeHistory(paper)}*/}
                {/* </Typography>*/}
                {/* {resumable && (*/}
                {/*  <Chip*/}
                {/*    size='small'*/}
                {/*    color='warning'*/}
                {/*    label='In progress'*/}
                {/*    sx={{ alignSelf: 'flex-start' }}*/}
                {/*  />*/}
                {/* )}*/}
                {/* <Button*/}
                {/*  size='small'*/}
                {/*  variant='contained'*/}
                {/*  disabled={!canSit(paper)}*/}
                {/*  onClick={() => navigate(`/cba/papers/${paper.id}`)}*/}
                {/*  sx={{ mt: 'auto', alignSelf: 'flex-start' }}*/}
                {/* >*/}
                {/*  {canSit(paper) ? startLabel(paper) : 'Not ready'}*/}
                {/* </Button>*/}
              </Card>
            </Grid>
          );
        })}
      </Grid>
    );
  }

  return (
    <Stack spacing={2} sx={{ mt: 3 }}>
      {papers.map((paper) => {
        const resumable = !!paper.inProgressAttempt && !paper.inProgressAttempt.expired;

        return (
          <Card
            key={paper.id}
            sx={{
              p: 3,
              borderRadius: 3,
              boxShadow: '0 2px 12px #0000001A',
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2,
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography variant='h6' sx={{ fontWeight: 600 }}>
                {paper.title}
              </Typography>
              <Typography variant='body2' sx={{ color: 'text.secondary', mt: 0.5 }}>
                {paper.questionCount} questions · {formatDuration(paper.durationMinutes)}
              </Typography>
              <Stack direction='row' spacing={1} sx={{ mt: 1 }} alignItems='center'>
                <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                  {describeHistory(paper)}
                </Typography>
                {resumable && <Chip size='small' color='warning' label='In progress' />}
              </Stack>
            </Box>

            <Button
              variant='contained'
              disabled={!canSit(paper)}
              onClick={() => navigate(`/cba/papers/${paper.id}`)}
            >
              {canSit(paper) ? startLabel(paper) : 'Not ready'}
            </Button>
          </Card>
        );
      })}
    </Stack>
  );
};

export default PaperList;
